import Controller from "csi/action/Controller";
import Request from "csi/def/Request";
import { INGREDIENT_CONTRIBUTOR } from "csi/service/rightPaneService";
import { rightPaneStore } from "csi/state/rootStore";
import { C8Node, cnl } from "csi/typings";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import IngredientContributorPaneComponent from "./IngredientContributorPaneComponent";

const MODULE = "FormulatedProduct";
const RECIPE_DATA_SHEET = "RecipeDataSheet";
const FOOD_BOM = "FoodBOM";

const FOOD_BOM_UPDATE_INGREDIENT_CONTRIBUTORS = "FoodBOMUpdateIngredientContributors";
const RECIPE_UPDATE_INGREDIENT_CONTRIBUTORS = "RecipeUpdateIngredientContributors";
const PARENT_DATA_SHEET_REVISION_URL = "ParentDataSheetRevisionURL";

const FLAT_INGREDIENT_ITEM = "FlatIngredientItem";
const RECIPE_DATA_SHEET_REVISION = "RecipeDataSheetRevision";
const FOOD_BOM_REVISION = "FoodBOMRevision";

const IngredientItemInspectAction = declare(Controller, {

	/**
	 * @override
	 * Opens the IngredientItemContributors
	 */
	process() {
		const ctx = this.getContext();

		const ingredientItem: C8Node = ctx.getNode();
		const cache = ctx.cache;

		const ingredientItemURL: cnl = ingredientItem.$URL;
		const foodIngredientURL: cnl = ingredientItem.LibraryItem;

		// Opens the right view to ingredientContributor
		function openRightPaneView(): void {
			rightPaneStore.setSelected(INGREDIENT_CONTRIBUTOR);
			if (rightPaneStore.selected instanceof IngredientContributorPaneComponent) {
				const component: IngredientContributorPaneComponent =
					rightPaneStore.selected as IngredientContributorPaneComponent;

				component.setIngredientItemURL(ingredientItemURL);
				component.setFoodIngredientURL(foodIngredientURL);
				component.setCache(cache);
			}
		};

		openRightPaneView();
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Add Parameter URL with the value of Recipe Revision - Master
	 * Add Parameter String calculate option: "Update" or "Reset"
	 */
	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);

		const ctx = this.getContext();
		const cache = ctx.cache;

		const fldsRevisionURL = this.getParent()?.$URL;
		const parentDataSheetRevisionURL = cache.get(fldsRevisionURL)?.ParentDataSheetRevision;
		const dataSheetURL = cache.get(parentDataSheetRevisionURL)?.__Parent__;

		call.addParameter("URL", xml.ATTR_REF, dataSheetURL);
		call.addParameter(PARENT_DATA_SHEET_REVISION_URL, xml.ATTR_REF, parentDataSheetRevisionURL);

		return call;
	},

	/**
	 * @override
	 * If there are no ingredient item contributors then update the children and values to populate
	 */
	toWriter() {
		const ctx = this.getContext();
		const cache = ctx.cache;
		const action = this.getAction();

		const currentNode = ctx.getNode();
		const currentNodeType = currentNode.$Type;

		const foodLabelDataSheet = currentNodeType === FLAT_INGREDIENT_ITEM ? 
			this.getParent() :
			ctx.cache.get(currentNode?.ParentLabelDataSheetRevision);

		const dataSheetRevision = currentNodeType === FLAT_INGREDIENT_ITEM ? 
			cache.getPathNode(this.getParent(), "Child:__Parent__/Child:__Parent__") :
			ctx.cache.get(currentNode?.ParentDataSheetRevision);

		const contributorLength: number = foodLabelDataSheet?.IngredientContributors?.length;
		const emptyContributors: boolean = contributorLength ? contributorLength === 0: true;

		const dataSheetRevisionType = dataSheetRevision.$Type;
		
		let operation: string;
		switch (dataSheetRevisionType) {
			case RECIPE_DATA_SHEET_REVISION:
				operation = RECIPE_UPDATE_INGREDIENT_CONTRIBUTORS;
				break;
			case RECIPE_DATA_SHEET:
				operation = RECIPE_UPDATE_INGREDIENT_CONTRIBUTORS;
				break;
			case FOOD_BOM_REVISION:
				operation = FOOD_BOM_UPDATE_INGREDIENT_CONTRIBUTORS;
				break;
			case FOOD_BOM:
				operation = FOOD_BOM_UPDATE_INGREDIENT_CONTRIBUTORS;
				break;
			default:
				break;
		}

		let request: Request;
		if (emptyContributors && operation) {
			request = lang.mixin(new Request(), {
				m_module: MODULE,
				m_operation: operation,
			});
		}

		action.m_request = request;
		return request ? this.toWriterRequest() : null;
	},
});

export = IngredientItemInspectAction;